import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CrowselCard from "./CrowselCard";
import CrowselCard2 from "./CrowselCard2";
import JobOpening from "./JobOpening";

import sliderImg1 from"./sliderImg1.jpg"
import sliderImg2 from"./sliderImg2.jpg"
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { toast } from '../common/Toast/toast';


const HeroSection1 = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const slides =[sliderImg1,sliderImg2];
  const navigate = useNavigate();
  const hasShownToast = useRef(false);
  const { hasPermission } = useAuth();
  useEffect(() => {
    if (!hasPermission('student-id-card', 'view','lms')) {
      if (!hasShownToast.current) {
        toast.error('You do not have permission to add departments.');
        navigate('/');
        // console.log("hello")
        hasShownToast.current = true;
      }
    }
  }, [hasPermission, navigate]);
  return (
    <div className="slide w-full mx-auto">
      <Slider {...settings}>
        {slides.map((image, idx) => (
          <div key={idx} className="slide-container">
          <img 
            src={image}
            alt="Slide" 
            className="img-fluid w-100 rounded"
            style={{ height: "50vh", objectFit: "cover" }} 
          />
        </div>
        
        ))}
      </Slider>
      <CrowselCard/>
      <CrowselCard2/>
      <JobOpening/>
    </div>
  );
};
export default HeroSection1;
